export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtSzakazkadruh';
export const NAME = 'ZakazkaDruh';
